import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AppBlockingIcon from "@mui/icons-material/AppBlocking";

const HomeScreenParentTable = ({
  parentName,
  data,
  onEdit,
  onOpenPlanPopup,
  onAppBlock,
}) => {
  return (
    <TableContainer component={Paper} sx={{ mb: 3 }}>
      <Typography variant="h6" p={2}>
        {parentName}
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Key</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Order</TableCell>
            <TableCell>Active</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No records
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.key}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.order}</TableCell>
                <TableCell>{row.active ? "Active" : "Inactive"}</TableCell>
                <TableCell>
                  <IconButton onClick={() => onEdit(row)}>
                    <EditIcon />
                  </IconButton>
                  {parentName === "Explore Grid" && (
                    <>
                      <IconButton
                        onClick={() => onOpenPlanPopup && onOpenPlanPopup(row)}
                      >
                        <AddCircleIcon color="success" />
                      </IconButton>
                      <IconButton onClick={() => onAppBlock && onAppBlock(row)}>
                        <AppBlockingIcon color="error" />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HomeScreenParentTable;
